export type EditPermissionsJSON = {
    authorization: {
        edit_speakers: boolean
        edit_transcript: boolean
    }
}

export type EditPermissions = {
    editSpeakers: boolean
    editTranscript: boolean
}

export const EditPermissions = {
    fromJson: (json: EditPermissionsJSON): EditPermissions => ({
        editSpeakers: json.authorization.edit_speakers,
        editTranscript: json.authorization.edit_transcript,
    }),
}
